export default __webpack_public_path__ + "static/media/main_title.abd72fe2.svg";